import useCapabilities, { useCanViewPersonEducationBool } from "@/hooks/useCapabilities";

export function usePersonEducationCapability() {
  const { loaded } = useCapabilities();
  const canViewPersonEducation = useCanViewPersonEducationBool();

  return {
    loaded,
    canViewPersonEducation
  };
}

/** Capability check for education routes. Denied users are redirected by `education/_TabLayout` or route-local `Navigate`. */
export function usePersonEducationAccess() {
  return usePersonEducationCapability();
}
